import { Progress } from 'antd'
import { useCountDown } from 'ahooks'
import { helix } from 'ldrs'

helix.register()

export default function ImageLoading({ item }: any) {
  const [countdown] = useCountDown({
    leftTime: 10000,
  })

  const percent = ((10000 - countdown) / 10000) * 100

  if (item.text || item.pic || item.audio || item.video) {
    return null
  }

  return (
    <div className="flex items-center justify-center flex-col gap-3 w-52 max-w-[80%] m-auto py-10">
      <l-helix size="45" speed="2.5" color="#4060e5"></l-helix>
      <span className="text-lg text-[#4060e5] text-center">{`${Math.round(percent)}%`}</span>
      <Progress percent={percent} showInfo={false} strokeColor="#4060e5" />
      <span>AI 作图中，请稍后...</span>
    </div>
  )
}
